module.exports = __webpack_public_path__ + "img/about-m-slide-10.3f056198.jpg";